// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deal-grid{display:grid;grid-column-gap:2rem;-webkit-column-gap:2rem;-moz-column-gap:2rem;column-gap:2rem;margin-left:-1.5rem;margin-right:-1.5rem;padding-left:1.5rem;padding-right:1.5rem;grid-template-columns:100px minmax(80px,1fr) minmax(100px,1fr) 120px minmax(60px,.8fr) minmax(100px,1.2fr) minmax(100px,1fr) minmax(120px,1.2fr) 48px}", ""]);
// Exports
module.exports = exports;
